import Vue from 'vue';
import { MethodEditorState, stateKey } from "./MethodEditorState";
import { MethodMainModal } from "./components/MethodMainModal";
import { Inject } from 'vue-property-decorator';
import { formatCodeWithMonaco } from '@tencent/ui-core/lib/utils/monaco';
export default class MethodEditor {
  constructor() {
    this.state = new MethodEditorState();
  }
  init(options) {
    this.state.options = options;
  }
  mount() {
    if (this.mainModal) return;
    const {
      state
    } = this;
    const modal = new Vue({
      provide: {
        [stateKey]: state
      },
      computed: {
        state() {
          return state;
        }
      },
      render(h) {
        return h(MethodMainModal);
      }
    });
    const el = document.createElement('div');
    document.body.appendChild(el);
    modal.$mount(el);
    this.mainModal = modal;
  }
  async create(options) {
    try {
      // 在新建模式第一次加载monaco可能导致无法添加方法，这里hack避免下
      await formatCodeWithMonaco('');
    } catch (error) {
      console.error(error);
    }
    this.mount();
    this.state.initCreateMode(options);
  }
  edit(options) {
    this.mount();
    this.state.initEditMode(options);
  }
  hide() {
    this.state.hide();
  }
  dispose() {
    var _this$mainModal;
    this.state.dispose();
    (_this$mainModal = this.mainModal) === null || _this$mainModal === void 0 || _this$mainModal.$destroy();
    // todo
  }
}
export const methodEditorInjectKey = '@wuji_source/MethodEditor';
export const IMethodEditor = Inject(methodEditorInjectKey);
//# sourceMappingURL=index.js.map
